import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlSqueezeComponent } from './control-squeeze/control-squeeze.component';
import { Compiler, COMPILER_OPTIONS, CompilerFactory } from '@angular/core';
import { JitCompilerFactory } from '@angular/platform-browser-dynamic';
import { SharedModule } from '../shared/shared.module';
export function createCompiler(compilerFactory: CompilerFactory) {
  return compilerFactory.createCompiler();
}

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [
    ControlSqueezeComponent
  ],
  exports: [
    ControlSqueezeComponent
  ],
  providers: [
    { provide: COMPILER_OPTIONS, useValue: {}, multi: true },
    { provide: CompilerFactory, useClass: JitCompilerFactory, deps: [COMPILER_OPTIONS] },
    { provide: Compiler, useFactory: createCompiler, deps: [CompilerFactory] }
  ]
})
export class HelperModule { }
